var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkColor = function SvgLinkColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#18A87D",
    fillRule: "evenodd",
    d: "M13.139 7.36a3.653 3.653 0 0 1 6.194 2.6 3.66 3.66 0 0 1-1.026 2.573l-.007.008-1.828 1.83a3.654 3.654 0 0 1-5.512-.396.61.61 0 0 1 .976-.73 2.438 2.438 0 0 0 3.675.263l1.823-1.825a2.44 2.44 0 0 0-1.735-4.13 2.44 2.44 0 0 0-1.71.682l-1.045 1.039a.609.609 0 1 1-.86-.865l1.049-1.042zm-2.97 3.429a3.65 3.65 0 0 1 4.204 1.236.61.61 0 0 1-.976.73 2.437 2.437 0 0 0-3.674-.263l-1.824 1.826a2.44 2.44 0 0 0 1.735 4.13 2.44 2.44 0 0 0 1.71-.682l1.038-1.039a.609.609 0 1 1 .862.863l-1.042 1.042-.008.008A3.653 3.653 0 0 1 6 16.04a3.66 3.66 0 0 1 1.026-2.573l.007-.008 1.828-1.829c.37-.371.816-.658 1.307-.841",
    clipRule: "evenodd"
  })));
};
export default SvgLinkColor;